import { useSonTranslation } from '../../../../translation/useSonTranslation';
import React, { useCallback } from 'react';
import {
  AcceptDeclineForm,
  Form,
  Row,
  SonForm,
  SubmitButton,
  Textarea,
  TextAreaParam,
  useForm,
} from '../../../../_lib/Form2';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { useDelayed } from '../../../../hooks/useDelayed';
import { RefreshCallback } from '../../../../_lib/FetchContainer';

export type ChangeAccessLevelDeclineFormTypes = TextAreaParam<'declineReason'>;

type AccessLevelAcceptDeclineFormProps = {
  approveForm: SonForm<any>;
  declineForm: SonForm<ChangeAccessLevelDeclineFormTypes>;
  refresh: RefreshCallback;
};

export function ChangeAccessLevelAcceptDeclineForm({
  approveForm,
  declineForm,
  refresh,
}: AccessLevelAcceptDeclineFormProps) {
  const { t } = useSonTranslation('AccessLevel');
  const { formProps, fetchState, params } = useForm({ form: declineForm });

  const [showModal, setShowModal] = React.useState(false);
  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const declineReasonParam = params.findByName('declineReason');

  const refreshAndClose = useCallback(() => {
    refresh();
    closeModal();
  }, [closeModal, refresh]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);

  return (
    <>
      <AcceptDeclineForm
        form={approveForm}
        headline={t('approveRequestHeadline')}
        messageSuccess={t('approveRequestForm.approve.status.success')}
        messageFail={t('approveRequestForm.approve.status.fail')}
        messageSending={t('approveRequestForm.approve.status.sending')}
        onDecline={() => setShowModal(true)}
        onSuccess={() => refresh()}
      />
      {showModal && (
        <ModalDialog closeModal={closeModal} headline={t('declineFormHeadline')} initialFocusIndex={1}>
          <Form {...formProps}>
            <Row>
              <Textarea label={t('labels.declineReasonLabel')} param={declineReasonParam} />
            </Row>
            <SubmitButton
              buttonLabel={t('labels.declineButtonLabel')}
              messageSuccess={t('approveRequestForm.decline.status.success')}
              messageSending={t('approveRequestForm.decline.status.sending')}
              messageFail={t('approveRequestForm.decline.status.fail')}
              fetchState={fetchState}
              onClick={delayedRefreshAndClose}
            />
          </Form>
        </ModalDialog>
      )}
    </>
  );
}
